import { createFileRoute } from '@tanstack/react-router'
import PrintOrderSection from 'Edition/components/sections/PrintOrder/PrintOrderSection'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/print-orders')({
    component: PrintOrderSection,
})
